export const SIGN_WIDGET_PARENT_ID = 'sign-widget-parent';
export const SIGN_WIDGET_ID = 'sign-widget';
export const SIGN_WIDGET_URI = 'https://eu.iit.com.ua/sign-widget/v20240301_new/';
export const SIGN_PAGINATION_SIZE = 20;
